import { mergeStyles, getTheme } from '@fluentui/react';

const palette = getTheme().palette;
export const videoHint = mergeStyles({
    backgroundColor: palette.neutralSecondary,
    bottom: '1%',
    height: '1.2rem',
    boxShadow: '0 0 1px 0 rgba(0,0,0,.16)',
    color: palette.neutralLighter,
    fontSize: '1rem',
    lineHeight: '1rem',
    textAlign: 'left',
    left: '2%',
    overflow: 'hidden',
    position: 'absolute',
    padding: '0.1rem',
    whiteSpace: 'nowrap',
    maxWidth: '95%',
    borderRadius: 4,
    textOverflow: 'ellipsis',
    zIndex: -1
});
export const mediaContainerNoLabel = mergeStyles({
    position: 'relative',
    height: '100%',
    width: '100%',
    background: 'transparent'
});
export const mediaContainerWithLabel = mergeStyles({
    position: 'relative',
    height: 'calc(100% - 1.2rem)',
    width: '100%',
    background: 'transparent'
});
export const MediaControlsContainer = mergeStyles({
    position: 'relative',
    height: '60%',
    background: 'transparent',
    padding: '10px 12px', /* Some padding */
    /*width: '50%',*/
    display: 'block'
});

export const LabelContainer = mergeStyles({
    position: 'relative',
    height: '1.2rem',
    width: '100%',
    background: 'transparent',
    bottom:'10%'
});
export const LabelContainerNoRelative = mergeStyles({
    height: '10%',
    width: '100%',
    background: 'transparent'
});

export const localVideoContainerStyle = mergeStyles(mediaContainerWithLabel, {
    width: '100%',
    height: 'calc(100% - 1.2rem)',
});
export const hiddenStyle = mergeStyles({
    visibility: 'hidden'
});
export const displayNoneStyle = mergeStyles({
    display: 'none'
});